module.exports = __webpack_public_path__ + "img/SEJ_eventos_Ir_a_seccion.b9c3d993.svg";